<template>
<div id="app">
    <transition name="fade">
<div v-if="loaded">        
        <b-container fluid="xl" class="topbar">
            <b-row>
                <b-col>
                <div class="logo">
                    <router-link to="/"><img class="logoimg" src="./img/logographiko.png"></router-link>
                </div>
            </b-col>
            <b-col>
                <div v-if="langfrench">
                    <b-container fluid="lg">

                        <div>

                            <b-navbar toggleable="lg" type="dark" class="mynav">
                                <b-navbar-brand href="#"></b-navbar-brand>

                                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                                <b-collapse id="nav-collapse" is-nav>
                                    
                                    <b-navbar-nav class="mx-auto">

                                        <b-nav-item to="/work/all/list">Nos Réalisations</b-nav-item>
                                        <b-nav-item to="/about">L'Agence</b-nav-item>
                                        <b-nav-item to="/contact">Contact</b-nav-item>

                                        <b-nav-item-dropdown text="" right no-caret>
                                            <template slot="button-content">
                                                <b-icon icon="globe" class="myglobeicon" v-b-tooltip.hover.top title="Choose language" font-scale="0.99"></b-icon>
                                            </template>
                                            <b-dropdown-item @click="toggleenglishlangage()">EN</b-dropdown-item>
                                            <b-dropdown-item @click="togglefrenchlangage()">FR</b-dropdown-item>
                                        </b-nav-item-dropdown>

                                    </b-navbar-nav>

                                </b-collapse>
                            </b-navbar>

                        </div>
                        
                    </b-container>
                </div>
                <div v-else>
                    <b-container fluid="lg">

                        <div>

                            <b-navbar toggleable="lg" type="dark" class="mynav">
                                <b-navbar-brand href="#"></b-navbar-brand>

                                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                                <b-collapse id="nav-collapse" is-nav>

                                    <b-navbar-nav class="mx-auto">
                                        
                                        <b-nav-item class="ml-2 mr-2" to="/work/all/list">Works</b-nav-item>
                                        <b-nav-item class="ml-2 mr-2" to="/about">About</b-nav-item>
                                        <b-nav-item class="ml-2 mr-2" to="/contact">Contact</b-nav-item>

                                        <b-nav-item-dropdown text="" right no-caret>
                                            <template slot="button-content">
                                                <b-icon icon="globe" class="myglobeicon" v-b-tooltip.hover.top title="Choose language" font-scale="0.99"></b-icon>
                                            </template>
                                            <b-dropdown-item @click="toggleenglishlangage()">EN</b-dropdown-item>
                                            <b-dropdown-item @click="togglefrenchlangage()">FR</b-dropdown-item>
                                        </b-nav-item-dropdown>

                                    </b-navbar-nav>

                                </b-collapse>
                            </b-navbar>

                        </div>

                    </b-container>
                </div>
            </b-col>

        </b-row>
    </b-container>
    <b-container>
        <b-row>
            <b-col class="greenbar">               
            </b-col>
        </b-row>
    </b-container>
    <b-container fluid="xl" class="maincontainer">

        <router-view />
    </b-container>
    <b-container v-if="!isContactPage" fluid="xl">
        <b-row>
            <b-col>
                <div :style="{ 'background-image': 'url(' + linkimage + ')' }" class="writeus">
                    <b-container fluid="xl">
                        <b-row>
                            <b-col lg="6" md="6" sm="6" xs="12" class="mt-5 mb-5 leftconsult" align-self="center">
                                <div v-if="langfrench">
                                    <span class="titleconsult">
                                        Nous contacter<br>
                                    </span>
                                    <span class="titleconsulte">pour </span>
                                    <span class="titleconsult2">démarrer</span><br>
                                    <span class="titleconsulte">un </span> <span class="titleconsult">projet</span>
                                </div>
                                <div v-else>
                                    <span class="titleconsult">
                                        Consult us<br>
                                    </span>
                                    <span class="titleconsulte">to </span>
                                    <span class="titleconsult2">start</span><br>
                                    <span class="titleconsulte">your </span> <span class="titleconsult3">project</span>
                                </div>
                            </b-col>
                            <b-col lg="6" md="6" sm="6" xs="12" class="mt-5 mb-5">
                                <b-form @submit="onSubmit">
                                    <b-row>
                                        <b-col class="mr-0 ml-5">
                                            <b-form-group id="input-group-3" :label="this.nom" label-for="input-3">
                                                <b-form-input id="input-3" v-model="form.nom" required :placeholder="this.votre_nom" :style="{ 'background-color': '#54bebe', 'color':'white'}"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col class="mr-5 ml-5">
                                            <b-form-group id="input-group-3" :label="this.prenom" label-for="input-3">
                                                <b-form-input id="input-3" v-model="form.prenom" required :placeholder="this.votre_prenom" :style="{ 'background-color': '#54bebe', 'color':'white'}"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col class="mr-0 ml-5">
                                            <b-form-group id="input-group-3" :label="this.phone" label-for="input-3">
                                                <b-form-input id="input-3" v-model="form.phone" required :placeholder="this.votre_tel" :style="{ 'background-color': '#54bebe', 'color':'white'}"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col class="mr-5 ml-5">
                                            <b-form-group id="input-group-3" :label="this.email" label-for="input-3">
                                                <b-form-input type="email" id="input-3" v-model="form.email" required :placeholder="this.votre_email" :style="{ 'background-color': '#54bebe', 'color':'white'}"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mr-4 ml-4">
                                        <b-col>
                                            <b-form-group id="input-group-3" :label="this.message" label-for="input-3">
                                                <b-form-textarea v-model="form.message" required :placeholder="this.votre_message" rows="3" max-rows="6" id="textarea-no-resize" no-resize :style="{ 'background-color': '#54bebe', 'color':'white', 'overflow':'hidden !important' }"></b-form-textarea>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <b-button type="submit" v-if="langfrench" pill variant="outline-secondary">Envoyer</b-button>
                                            <b-button type="submit" v-else pill variant="outline-secondary">Send</b-button>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>

            </b-col>
        </b-row>
    </b-container>
    <b-container v-else fluid="xl">
        <b-row>
            <b-col>
                <div :style="{ 'background-image': 'url(' + linkimage + ')' }" class="writeus">
                    <b-container>
                        <b-row>
                            <b-col>
                                <div class="contactLine">
                                </div>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>
            </b-col>
        </b-row>
        
    </b-container>
    
    <div id="headlinediv"></div>
    <div v-if="langfrench">
        <b-container fluid="xl" class="footer pt-5 pb-5">
            <b-row>
                <b-col lg="3" md="3" sm="6" xs="12" class="mt-5 mb-5 pr-1" align-self="center">
                    <b-img class="ml-5 mr-5 " :src="wurl+'/imgsrv/graphikowhite3.png'" fluid />
                </b-col>
                <b-col lg="3" md="3" sm="6" xs="12" class="mt-5 mb-5 text-center" align-self="center">
                    <div class="footerlink">

                        <router-link to="/work/all/list">Nos Réalisations</router-link><br>
                        <router-link to="/about">L'Agence</router-link><br>
                        <router-link to="/contact">Contact</router-link><br>
                    </div>
                </b-col>
                <b-col lg="3" md="3" sm="6" xs="12" class="mt-5 mb-5" align-self="center">
                    <span class="textftr">Notre expertise</span><br><br>
                    <span class="worktxt">Design et Développement Web<br>
                        Développement d'Application Mobile<br>
                        Reportage Vidéo<br>
                        Création Maquette Graphique Digitale<br>
                        Réalisation d'Émission TV et Web TV<br>
                        Réalisation de Film Publicitaire<br>
                        Création de Logo<br>
                        Publicité Radio<br></span>
                </b-col>
                <b-col lg="3" md="3" sm="6" xs="12" class="mt-5 mb-5" align-self="center">
                    <span class="textftr">Contact</span><br>
                    <div v-if="!isContactPage">
                    <b-button type="submit" v-if="langfrench" pill variant="outline-secondary" class="mt-3" @click='writeUsonHome()'>Ecrivez-nous</b-button><br><br>
                    ou appeler nous au<br></div>
                    <span class="fontnum">+261 32 02 022 32</span><br>
                    info@graphikodesign.com<br>

                </b-col>
            </b-row>
        </b-container>
    </div>
    <div v-else>
        <b-container fluid="xl" class="footer pt-5 pb-5">
            <b-row>
                <b-col lg="3" md="3" sm="6" xs="12" class="mt-5 mb-5" align-self="center">
                    <b-img class="ml-5 mr-5 " :src="wurl+'/imgsrv/graphikowhite3.png'" fluid />
                </b-col>
                <b-col lg="3" md="3" sm="6" xs="12" class="mt-5 mb-5 text-center" align-self="center">
                    <div class="footerlink">
                        
                        <router-link to="/work/all/list">Works</router-link><br>
                        <router-link to="/about">About</router-link><br>
                        <router-link to="/contact">Contact</router-link><br>
                    </div>
                </b-col>
                <b-col lg="3" md="3" sm="6" xs="12" class="mt-5 mb-5" align-self="center">
                    <span class="textftr">What we do</span><br><br>
                    <span class="worktxt">Web Design & Development<br>
                        Mobile Application Development<br>
                        Corporate Video<br>
                        Graphic Design<br>
                        TV and WebTV<br>
                        Commercial<br>
                        Logo Creation<br>
                        Radio Commercial<br></span>
                </b-col>
                <b-col lg="3" md="3" sm="6" xs="12" class="mt-5 mb-5" align-self="center">
                   <span class="textftr">Contact</span><br>
                    <div v-if="!isContactPage">
                        <div v-if="langfrench">
                            <b-button type="submit"  pill variant="outline-secondary" class="mt-3" @click='writeUsonHome()'>Ecrivez-nous</b-button><br><br>
                        </div>
                        <div v-else>
                            <b-button type="submit" pill variant="outline-secondary" class="mt-3" @click='writeUsonHome()'>Write to us</b-button><br><br>
                        </div>
                    or mail us to<br></div>
                    info@graphikodesign.com<br>

                </b-col>
        
            </b-row>
        </b-container>
    </div>
    
    
<b-container>
    <b-row>
        <b-col class="greenbar">               
            </b-col>
        </b-row>
    </b-container>
    <b-container fluid="xl" class="footerbottom">
        <b-row>
            <b-col class="mt-5 mb-5">
                <div class="text_en_bas">
                    <span class="textfooter1">© {{ this.here_is_current_year }} Graphikodesign </span>
                </div>
            </b-col>
        </b-row>
    </b-container>
    <div v-if="ask_for_cookie" class="cookieasker">
        <b-alert v-model="showAlert" show dismissible>
            <b-row>
                <b-col>
                    <div v-if="langfrench">
                        Les cookies sont utiles pour faciliter la personnalisation de votre accès à nos services en ligne. Vous êtes libre d'accepter ou de refuser les cookies en configurant votre navigateur internet
                    </div>
                    <div v-else>
                        Cookies are useful to facilitate the personalization of your access to our online services. You are free to accept or refuse cookies by configuring your web browser
                    </div>
                </b-col>
                <b-col>
                    <b-row class="text-right" align-v="center">
                        <b-col cols="12" md="8">
                            {{ defaultChooseLang }}:
                        </b-col>
                        <b-col cols="12" md="4" class="text-center">
                            <b-form-select @change="checkLang" v-model="selectedLang" :options="options" class="mb-3" value-field="item" text-field="name" disabled-field="notEnabled"></b-form-select>
                        </b-col>
                    </b-row>
                    
                </b-col>

            </b-row>
            <b-row>
                <b-col>
                    <b-button @click="acceptcookie()">{{ defaultCookieAcceptButtonText }}</b-button>
                </b-col>
            </b-row>
        </b-alert>
    </div>
</div>
</transition>
</div>
</template>

<script>
//bus for handling component interconnection
import {
    EventBus
} from "@/event-bus.js";
import axios from 'axios'
import {
    globalSiteSetting
} from "./main.ts";

export default {
    data() {
        return {

            wurl: globalSiteSetting.siteurl,
            linkgdbackground: 'require("@/img/gdbackg.png")',
            here_is_current_year: '',
            showAlert: true,
            ask_for_cookie: false,
            isContactPage: false,
            langfrench: 'true',
            selectedLang: 'fr',
            defaultChooseLang: 'Langue du site',
            defaultCookieAcceptButtonText: 'Accepter',
            loaded: false,

         
            options: [{
                    item: 'fr',
                    name: 'French'
                },
                {
                    item: 'en',
                    name: 'English'
                }
            ],
            nom: '',
            votre_nom: 'Votre nom',

            prenom: '',
            votre_prenom: 'Votre prénom',

            email: '',
            votre_email: 'Votre email',

            phone: '',
            votre_tel: 'Votre numéro téléphone',

            message: '',
            votre_message: 'Votre message...',

            form: {
                nom: '',
                prenom: '',
                email: '',
                phone: '',
                message: ''

            },
        }
    },
    methods: {
        returncurrentdate() {
            var currentdate = new Date()
            var currentyear = ''
            currentyear = currentdate.getFullYear()
            this.here_is_current_year = currentyear
            //console.log("the current year is: "+currentyear)
        },
        checkifcookieexistornot() {

            if (this.$cookie.get('gd_cookie') === 'accepted' || this.$cookie.get('gd_cookie') === 'rejected') {

                // try to read lang conf
                if (this.$cookie.get('gd_cookie') === 'accepted') {
                    if (this.$cookie.get('gd_langinfrench') === 'true') {
                        this.langfrench = true
                        EventBus.$emit('togglelangtofrench')
                    } else {
                        this.langfrench = false
                        EventBus.$emit('togglelangtoenglish')
                    }
                }

            } else {
                this.askforcookie()
            }
        },
        checkLang(key, keyPath) {

            if (key == 'fr') {
                this.langfrench = true
                EventBus.$emit('togglelangtofrench')
                this.defaultChooseLang = 'Langue du site'
                this.defaultCookieAcceptButtonText = 'Accepter'
                //console.log('lang is french')
            } else {
                this.langfrench = false
                EventBus.$emit('togglelangtoenglish')
                this.defaultChooseLang = 'Choose website langage'
                this.defaultCookieAcceptButtonText = 'Accept'
                //console.log('lang is english')
            }
        },
        askforcookie() {
            this.ask_for_cookie = true
            this.showAlert = true
            //console.log('launch ask for cookie')
        },
        acceptcookie() {
            //console.log('cookie was accepted for write')
            //write to gd_cookie for cookie is accepted
            this.$cookie.set('gd_cookie', 'accepted', 90);
            this.$cookie.set('gd_langinfrench', this.langfrench, 90);
            this.ask_for_cookie = false
        },

        togglefrenchlangage() {
            this.langfrench = true
            this.defaultChooseLang = 'Langue du site'
            this.defaultCookieAcceptButtonText = 'Accepter'
            EventBus.$emit('togglelangtofrench')
            //console.log('lang is now french')
            //write to cookie
            this.selectedLang = 'fr'
            this.votre_nom = 'Votre nom',
                this.votre_prenom = 'Votre prénom',
                this.votre_email = 'Votre email',
                this.votre_tel = 'Votre numéro téléphone',
                this.votre_message = 'Votre message...',

                this.$cookie.set('gd_langinfrench', this.langfrench, 90);
        },
        toggleenglishlangage() {
            this.langfrench = false
            this.defaultChooseLang = 'Choose website langage'
            this.defaultCookieAcceptButtonText = 'Accept'
            this.selectedLang = 'en'

            this.votre_nom = 'Name',
                this.votre_prenom = 'First name',
                this.votre_email = 'Email',
                this.votre_tel = 'Phone',
                this.votre_message = 'Your message...',

                EventBus.$emit('togglelangtoenglish')
            //write to cookie
            this.$cookie.set('gd_langinfrench', this.langfrench, 90);
            //console.log('lang is now english')
        },
        writeUsonHome() {
             console.log("launch for write us")
             this.$router.push('/contact')
        },
        onSubmit(evt) {
            console.log("start sending message...")
            evt.preventDefault()
            //alert(JSON.stringify(this.form))
            var weburl = this.wurl;
            this.contenttosendtomail = 'Nom:' + this.form.nom + ' ' + '<br>' + 'Prénom:' + this.form.prenom + '<br>' + 'Tél:' + this.form.phone + '<br>' + 'Email:' + this.form.email + '<br>' + 'Message:' + this.form.message
            var url = weburl + '/api.data.php?req=postmail&type=quote&content=' + this.contenttosendtomail + '&auth=razafy'
            var urlencoded = encodeURI(url)

            axios.get(urlencoded)
                .then(response => {
                    //console.log('status is:' + response.data.message)
                    //console.log('content is:'+ response.data.content)
                    alert('Message envoyé avec succès')

                })
        }
    },

    mounted() {

      

        this.returncurrentdate()
        //set a cookie value
        //this.$cookie.set('test', 'Hello world!', 1);
        // This will set a cookie with the name 'test' and the value 'Hello world!' that expires in one day
        this.checkifcookieexistornot()
        //console.log('yes loaded')
        this.loaded = true

    },


    watch: {
        //this will test if cookie is rejected and write as is
        showAlert: function (val) {
            if (val === false) {
                this.$cookie.set('gd_cookie', 'rejected', 90);
                console.log('cookie was rejected')
            }
        },
        currentlink: function (val) {
            //console.log('current link:' + this.currentlink)
            if (this.currentlink == 'contact') {
                this.isContactPage = true
            } else {
                this.isContactPage = false
            }
        }

    },
    computed: {
        linkimage() {
            return this.wurl + '/imgsrv/gdbackg.png'
        },
        currentlink() {
            return this.$route.name
        }
    }
}
</script>

<style lang="scss">
// Import custom SASS variable overrides, or alternatively
// define your variable overrides here instead
@import 'assets/custom-vars.scss';

// Import Bootstrap and BootstrapVue source SCSS files
@import '~bootstrap/scss/bootstrap.scss';
@import '~bootstrap-vue/src/index.scss';

@font-face {
    font-family: 'MyNHG'; /* Name you will use in CSS */
    src: url('./assets/fonts/nhg55rg.woff2') format('woff2'),
         url('./assets/fonts/nhg55rg.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap; /* Helps control font loading behavior */
}
@font-face {
    font-family: 'MyNHGmd'; /* Name you will use in CSS */
    src: url('./assets/fonts/nhg65md.woff2') format('woff2'),
         url('./assets/fonts/nhg65md.woff') format('woff');
    font-weight: 400;
    font-display: swap; /* Helps control font loading behavior */
}
@font-face {
    font-family: 'MyNHGbd'; /* Name you will use in CSS */
    src: url('./assets/fonts/nhg75bd.woff2') format('woff2'),
         url('./assets/fonts/nhg75bd.woff') format('woff');
    font-weight: 400;
    font-display: swap; /* Helps control font loading behavior */
}

body {
    //overflow-x: hidden;
    height: 100%;
    position: relative;
    background-color: #D1D3D4 !important;
    font-family: 'Roboto', sans-serif;
    //     min-height: 100vh;
    overflow-x: hidden;
}

@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;1,300;1,400&display=swap');

#app {
    font-family: 'MyNHG','Avenir', Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #707f82;
    font-size: 14px;
}

//page content styling
.pagecontent {
    padding:15px;
    background-color: #fff;
}
.fade-enter-active, .fade-leave-active {
    transition: opacity 1.5s;
}
.fade-enter, .fade-leave-active {
    opacity: 0;
}

textarea:-moz-placeholder,
/* Firefox 18- */
textarea::-moz-placeholder,
/* Firefox 19+ */
textarea:-ms-input-placeholder,
/* IE 10+ */
textarea::-webkit-input-placeholder,
/* Webkit based */
textarea::placeholder {
    /* Modern browsers */
    color: #ffffff;
}

//greenbar for homepage
.greenbar {
    background: #07aaaa;
    height: 13px;
}


.form-control {
    background-color: #389595 important;
}

//transition effect
/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}

.leftconsult {
    color: white;
    line-height: 2em;
}

.titleconsult {
    font-size: 29pt;
    font-family: 'MyNHGbd';
}

.fontnum {
    font-size: 13pt;
    font-weight: 600
}

.titleconsulte {
    font-family: 'Avenir';
    font-size: 30pt;
    
}

.titleconsult2 {
    font-size: 32pt;
    font-weight: bolder;
}

.titleconsult3 {
    font-size: 36pt;
    font-weight: 900;
}

.writeus {
    background-size: cover;
    background-repeat: no-repeat, no-repeat;
    width: 100%;
}

.clienttxt {
    color: #1a1a1a;
}

.contactLine {
    height: 70px;
}

//change alert info color
.alert-info {
    color: #fff !important;
    background: #07aaaa !important;
    border-color: #bee5eb;
}

//class for animation
.animate {
    transition-delay: .1s;
    transition-duration: .25s;
    transition-timing-function: ease-in;
}

.slide-up {
    transform: translateY(0);
}

.slide-up.animate-active {
    transform: translateY(-100px);
}

//class for modal width
.modal .modal-portfolio {
    max-width: 969px;
}

//class for modal remove border 
.mainPortfolioContent {
    padding: 0px !important;
}

//adjust height in globe langage icon
.myglobeicon {
    position: relative;
    top: -4px;
}

//change portfolio navigation button
.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
    color: #e9ecef  !important;
    font-size: 12pt;
    background-color: #000000 !important;
}

//change portfolio categorie color link text
.nav-fill .nav-item a {
    color: #797b7b;
    font-size: 12pt;
    font-weight: bold;
}

.nav-fill .nav-item a:hover {
    color: #07aaaa;
}

// change background of tabs portfolio 
.card-body {
    background-color: #f0f0f0;
}

.mainPortfolioContent {
    position: relative;
    padding: 15px;
}

.maintPortfolioContentText {

    position: relative;
    padding: 15px;

}

.before-enter {
    opacity: 0;
    transform: translateY(100px);
    transition: all 1s ease-out;

}

.enter {
    opacity: 1;
    transform: translateY(0px);
}

/* hover effets css */
.picportfoliohome {
    overflow: hidden;
    position: relative;
    cursor: pointer;
}

.piclogoclienthome {
    overflow: hidden;
    position: relative;
}

.picportfoliohome img {
    position: re;
    left: -15px;
    width: 100%;
    filter: grayscale(0.5) saturate(0) opacity(0.9);
}

.piclogoclienthome img {
    position: re;
    left: -15px;
    width: 100%;
    filter: grayscale(100%);
    opacity: .9;
}

.contentpic {
    padding-bottom: 10px;
}

.picportfoliohome:hover {
    transform: scale(1.08);
    transition: all 0.5s;

}

.picportfoliohome:hover img {
    transition: 0.3s;
    filter: grayscale(0%);
    opacity: 1;
}

.piclogoclienthome:hover {
    transform: scale(1.04);
    transition: all 0.5s;

}

.piclogoclienthome:hover img {
    filter: grayscale(0%);
}

.textcaption {
    position: absolute;
    top: 169px;
    width: 100%;

    text-align: center;
    color: white;
    z-index: 99;
    display: flex;
    justify-content: center;
}

.textcaption h3 {
    font-weight: bolder;
}

.picportfoliohome:hover .textcaption {
    top: 135px;
    transition: all 0.5s;
}

.textinside {
    position: absolute;
    top: 195px;
    color: white;
    z-index: 99;
    left: 3%;
    width: 95%;
    justify-content: center;
    opacity: 0
}

.picportfoliohome:hover .textinside {
    opacity: 1;
    top: 169px;
    transition: all 0.6s;
}

.overlayonhover {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    background: rgb(117, 117, 117);
    opacity: 0.45;
    z-index: 100;

}

.picportfoliohome:hover .overlayonhover {
    opacity: 0.0;
    transition: all 0.6s;
}

.picportfoliohome img {
    left: 0px;
}

/* end of hover effect css */

.nl2br {
    white-space: pre;
}

.cookieasker {
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 100;
}

/* fix container to fit width to 100% */
.container,
.container-sm,
.container-md {
    max-width: 100% !important;
}

.breadcrumb-item a {
    color: #718293 !important;
}

.breadcrumb-item.active {
    color: #b4bfbe !important;
}

.card {
    border: none !important;
}

.titleframecontainer {
    display: table;
    font-size: 13pt;
    width: 100%;
    height: 60px;

}

.titleframe {
    z-index: 100;
    color: #62676d;
    vertical-align: middle;
    font-weight: bolder;
    display: table-cell;
    border: 2px solid rgba(178, 178, 178, 0.48);

}

.titlehautecouture {
    background: #959d9f;
    color: #d2dddf;
    margin-left: 0px !important;
    margin-right: 0px !important;
}

.tittle_bottom {
    font-weight: bolder;
    font-size: 16px;
}

.bottom_address {
    width: 100%;
    color: #2f2f2f;
    font-size: 12px;
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    line-height: 14px;
}

.card-text {
    line-height: 18px;
    color: #809297;
}

.card-title {
    color: #738286;
}

.footerlink a {

    color: #e8ffff;

}

.footerlink {
font-family: 'MyNHGmd';
    font-size: 26px;
    line-height: 1.8;
}

.footerlink a:hover {
    color: #43efef;
    text-decoration: none;
}

/* google map css code */
.map-responsive {
    overflow: hidden;
    padding-bottom: 94.25%;
    position: relative;
    height: 0;
}

.map-responsive iframe {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
}

.mapgoogle {
    padding: 1px;
}

.gm-style .review-box {
    display: none !important;
}

/* end of google map css code */

.contactform {
    padding: 18px;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23BAC4C6FF' stroke-width='3' stroke-dasharray='12' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e") !important;
}

.maincontainer {
    vertical-align: middle;
    overflow-x: hidden;
    min-height: 100%;
    height: 100%;
}

.content {
    padding-top: 7px;
    padding-bottom: 36px;
}

#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}

.mynav {
    margin-top: 20px;
    z-index: 100;
}

.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl {
    padding-left: 0px !important;
    padding-right: 0px !important;
}

.topbar {
    background: #FBFCFD;

}

.topright {
    float: right;
    display: block;
    position: relative;
    color: white;
    font-size: 11px;
    line-height: 12px !important;
    top: 31px;
    text-align: right;
    margin-right: 10px;
}

.logo {
    margin-top: 7px;
    margin-bottom: 8px;

}
.logoimg {
    position: relative;
    top:-8px;
}

.navbar-collapse .collapse {
    color: red !important;
}

/* change hamburger toggle icon color */
.navbar-toggler-icon {
    background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='rgba(0, 0, 0, 1)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>") !important;
}

/* change border hamburger color */
#button .navbar-dark .navbar-toggler .collapsed {
    border-color: rgb(0, 0, 0) !important;
}

/* reduce toggle icon size and border color*/
.navbar-toggler-icon {
    width: 1.0em !important;
    height: 1.0em !important;

}

/*
.navbar-toggler > .navbar-toggler-icon {
  background-color: black; 

}
*/
/* change navbar color text */
.navbar-dark .navbar-nav .nav-link {
    color: #2b2b2b !important;
    font-size: 15pt;
}

/* navbar height */
.navbar {
    min-height: 63px;

}

.footer {
    background: #022b2b;
    color: #f4ffff;

}

.footerbottom {

    background: #555252;
    color: #fff;
    font-size: 10px;
}

.divlogo {
    background-color: #07aaaa;
    margin: 100;
    padding: 2%;
    width: 50%;
}

.worktxt {
    line-height: 1.7em;
    font-size: 12pt;

}

.textfooter1 {
    font-size: 15px;
}

.textftr {
font-family: 'MyNHGmd';
    font-size: 19pt;
    color:#e8ffff
}

.textcopyright {
    color: #94a1af;
}

.textfooterbold {
    font-weight: bolder;
    font-size: 16px;
    color: #425f68;
}

.headlinehome {
    padding-top: 31px;
    padding-bottom: 31px;
    background: #f0f0f0;
}

.headerpic {
    background: #343737;
}

.txtabout {
    color: white;
    font-size: 15pt;

}

.txtbolder {
    font-weight: bolder;
}

.gdgrid {
    float: right;
}

.cancelbutton {
    margin-left: 10px;
}

.btn {
    background-color: #ffffff !important;
    color: #2c3e50 !important;
}

.btn:hover {
    background-color: #f0cd09 !important;
    color: #2c3e50 !important;
}

@media only screen and (max-width: 531px) {
    .logo img {
        max-width: 125%;
    }

    .mynav {
        margin-top: 11px;
    }
}

@media only screen and (max-width: 375px) {
    .topright {
        display: none;
    }

    .carousel-caption {
        top: 4%;
        line-height: 13px;
        font-size: 13px;
    }

    .carousel-caption h3 {
        font-size: 18px;
    }

.greenbar {
    height: 9px;
}

}

@media only screen and (max-width: 360px) {
    .topright {
        display: none;
    }

    .carousel-caption {
        top: 4%;
        line-height: 12px;
        font-size: 12px;
    }

    .carousel-caption h3 {
        font-size: 15px;
    }
}
</style>
